import { ActionTree } from 'vuex';

import * as sessionsAPI from '@/api/sessions'
import * as profileAPI from '@/api/profile'

import { StateType } from './state';
import route from '@/router/index.ts';

const redirectToLogin = () => {
  if (route.currentRoute.name !== 'login') {
    route.push({ name: 'login' });
  }
};

const redirectToHome = () => {
  if(localStorage.getItem('lastPath') != null && localStorage.getItem('lastPath') !== '/login') {
    route.push({path: localStorage.getItem('lastPath') ?? '/'});
    localStorage.removeItem('lastPath');
    return;
  }
  if (route.currentRoute.name !== 'forms') {
      route.push({name: 'forms'});
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const actions: ActionTree<StateType, any> = {
  async login({ commit, dispatch }, { email, password }) {
    try {
      const session = await sessionsAPI.login({ email, password });
      commit('setSession', session);
      const profile = await profileAPI.get();
      commit('setProfile', profile)
      redirectToHome();
      await dispatch('xmppClient/restoreFromSession', undefined, { root: true });
    } catch (e) {
      // Make sure to clear session
      commit('setSession', null);
      commit('setProfile', null);
      dispatch('xmppClient/teardown', undefined, { root: true });
      redirectToLogin();
      // Rethrow so that components can handle the error notification
      throw e;
    }
  },
  async restoreXMPP({ dispatch, rootGetters }) {
    if (rootGetters['xmppClient/isConnected']) return;
    try {
      await dispatch('xmppClient/restoreFromSession', undefined, { root: true });
    } catch (err) {
      localStorage.setItem('lastPath', window.location.pathname);
      await dispatch('logout');
      // throw err;
    }
  },
  async logout({ state, commit, getters, dispatch }) {
    if (!getters.exists || !state.session) {
      redirectToLogin();
      return;
    }

    try {
      await sessionsAPI.logout(state.session?.id);
    } finally {
      commit('setSession', null);
      commit('setProfile', null);
      await dispatch('xmppClient/teardown', undefined, { root: true });
      redirectToLogin();
    }
  },
};

export default actions;
